import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');

export const Card = styled.div`
  background-color: ${colors.white};
  border-radius: 2px;
  box-sizing: border-box;
  height: 24px;
  opacity: 0.8;
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-board/Card.js